import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { AddressData } from '@wellesley/openapi'

type SuggestionListProps = {
  suggestions: AddressData[]
  onSelect: (suggestion: AddressData) => void
}

const SuggestionList: FC<SuggestionListProps> = ({ suggestions, onSelect }) => (
  <ul className="flex flex-col">
    {suggestions.map((s, i) => {
      const handleMouseDown = (e: React.MouseEvent) => {
        e.preventDefault()
        onSelect(s)
      }
      return (
        <li
          key={i}
          data-testid="location-suggestion"
          className={cn(
            'rounded-m p-xxs cursor-pointer text-base font-medium hover:bg-gray-100',
          )}
          onMouseDown={handleMouseDown}
        >
          {s.formatted}
        </li>
      )
    })}
  </ul>
)

export default SuggestionList
